<template>
  <div class="navbar-index">
    <div class="container nav">
      <div class="logo">
        <img src="@/assets/image/logo.png" alt="" />
      </div>
      <ul>
        <template v-for="(item, index) in navBar">
          <li
            :key="index"
            :class="fullPath == item.link ? 'actived' : ''"
            @click="changeCurrent(item)"
          >
            {{ item.title }}
            <solution v-if="index == 2"></solution>
          </li>
        </template>
      </ul>
      <img
        src="@/assets/image/more.png"
        class="more"
        @click="showAside = !showAside"
      />
      <div class="aside-nav" :style="{ opacity: showAside ? 1 : 0 }">
        <template v-for="(item, index) in navBar">
          <li
            :key="index"
            :class="fullPath == item.link ? 'actived' : ''"
            @click="changeCurrent(item)"
          >
            {{ item.title }}
          </li>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import solution from "./comps/solution.vue";
export default {
  components: {
    solution,
  },
  data() {
    return {
      navBar: [
        {
          title: "首页",
          link: "/",
        },
        {
          title: "物联网平台",
          link: "/iot",
        },
        {
          title: "解决方案",
          link: "/solution",
        },
        {
          title: "客户案例",
          link: "/case",
        },
        {
          title: "关于我们",
          link: "/about",
        },
      ],
      showAside: false,
      fullPath: "",
    };
  },
  watch: {
    $route(val) {
      this.fullPath = val.fullPath;
    },
  },
  mounted() {
    this.fullPath = this.$route.fullPath;
    window.addEventListener("resize", (val) => {
      var width = document.documentElement.clientWidth;
      if (width > 1024) {
        this.showAside = false;
      }
    });
  },
  methods: {
    changeCurrent(item) {
      this.$router.push(item.link);
      this.showAside = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar-index {
  width: 100%;
  background-color: #fafafa;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  .nav {
    height: 5rem;
    display: flex;
    align-items: center;

    justify-content: space-between;
    position: relative;
    .logo {
      width: 12.5rem /* 200/16 */;
      height: 5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 75%;
      }
    }
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      li {
        cursor: pointer;
        color: #333333;
        font-size: 1rem;
        font-weight: bold;
        padding: 0 2rem /* 32/16 */;
        position: relative;
      }
      .actived {
        color: #0c9efb;
        position: relative;
      }
      .actived::after {
        content: " ";
        position: absolute;
        left: calc(50% - 0.1875rem /* 3/16 */);
        bottom: -1rem;
        width: 0.375rem /* 6/16 */;
        height: 0.375rem /* 6/16 */;
        background: #0c9efb;
        border-radius: 50%;
        transition: all 0.6s;
      }
    }
    .more {
      width: 28px;
      margin-right: 1.25rem /* 20/16 */;
      display: none;
    }
    .aside-nav {
      width: 12.5rem /* 200/16 */;
      border: 0.125rem /* 2/16 */ solid #dadada;
      background-color: #fafafa;
      position: absolute;
      right: 0;
      top: 5rem;
      opacity: 0;
      transition: all 0.6s;
      li {
        list-style: none;
        line-height: 3.125rem /* 50/16 */;
        text-align: center;
        border-bottom: 0.0625rem /* 1/16 */ solid #dadada;
      }

      li:nth-last-of-type(1) {
        border-bottom: none;
      }
    }
  }
}
/*媒体查询*/
/*屏幕宽度小于878px的时候执行里面的css*/
@media only screen and (max-width: 1024px) {
  .nav {
    padding: 0 1rem;
  }
  .nav .more {
    display: inline-block !important;
  }
  .nav ul {
    display: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/layout/navBar/index.vue